module.exports = __webpack_public_path__ + "static/djez_1-d95eb4c204bbe7339eebf1779d405321.jpg";